// Mixitup container
var containerEl = document.querySelector('.mixitup-news');
// Current limit
var currentLimit = 12;

$("tr:visible").each(function (index) {
    $(this).toggleClass("zebrastripe", !!(index & 1));
});

$(function () {
    // Scroll back to top of grid if pager is clicked
    $(document).on('click', 'button.mixitup-control', function () {
        $('html,body').animate({
            scrollTop: $("#NewsGridTable").offset().top - 100
        }, 'slow');
    });
});


var mixer = mixitup(containerEl, {
    multifilter: {
        enable: true,
        logicBetweenGroups: 'and'
    },
    selectors: {
        target: '[data-ref="mixitup-target"]'
    },

    pagination: {
        limit: currentLimit,
        maintainActivePage: true
    },

    animation: {
        duration: 200,
        effects: 'fade translateZ(100px)',
        reverseOut: true,
        nudge: false,
        easing: 'ease-in-out',
    },
    callbacks: {
        onMixEnd: function (state) {
            $("tr:visible").each(function (index) {
                $(this).toggleClass("zebrastripe", !!(index & 1));
            });
        }
    }
});

